import * as React from 'react';
import styled from 'styled-components';

import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { AgCharts } from "ag-charts-react";
import { Typography } from '@mui/material';
import { Event } from '@process-advisor/process-miner/api/events';


const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    margin-left: 10px; 
    margin-right: 10px;
    background-color: white;
    width: 800px;
`;

const ChartContainer = styled.div`
    max-height: 600px;
    height: 600px;
    min-height: 600px !important;
    overflow-y: auto;

    .ag-charts-wrapper {
        height: 600px !important;
    }
`;

export function TaskLifeCycle(){

    const [seriesData, setSeriesData] = React.useState([]);
    const [validData, setValidData] = React.useState(false);
    const [categoryData, setCategoryData] = React.useState([]);

    React.useEffect(() => {
        const listener = () => {
            updateGraph()
        }
        listener();
        apiProvider.on(Event.openLifecycleModalMulti, listener);

        return () => {
            apiProvider.off(Event.openLifecycleModalMulti, listener);
        };
    }, []);

    React.useEffect(() => {
        updateGraph()
    }, []);

    function updateGraph() {
        apiProvider.tasksVisualization()
        let tSeriesData = apiProvider.getLifecycleSeries().sort((a, b) => b.sort - a.sort)
        let tCategoryData = apiProvider.getLifecycleCategory().sort()

        setCategoryData(tCategoryData)
        setSeriesData(tSeriesData)
        if (tSeriesData.length > 0) {
            setValidData(true)
            setOptions({data: tCategoryData, series: tSeriesData})
        }
    }

    const [options, setOptions] = React.useState({
        height: 600,
        data: categoryData,
        series: seriesData,
    });

    return (
        <Wrapper>
            {validData === false ?
            <Typography
                variant="caption"
                align="center"
                sx={{ fontSize: '14px', fontWeight: '600', paddingTop: 1, fontFamily: 'system-ui'}}
                component="div">
                {'Please select a source for the lifecycle data'}
            </Typography>
            :
            <ChartContainer>
                <AgCharts options={options} />
            </ChartContainer>
            }
        </Wrapper>
    );
};
